import React from 'react';

export type VideoDownloadProps = {
  downloadableUrl?: string;
  downloadVideoInput?: {
    blockId: string;
    videoUID: string;
  };
};

export type IVideoDownloadProvider = {
  onDownload?: (props: VideoDownloadProps) => void;
  enableDownloadVideo: boolean;
};

const VideoDownloadContext = React.createContext<IVideoDownloadProvider>({
  enableDownloadVideo: false,
});

export const VideoDownloadProvider: React.FC<React.PropsWithChildren<IVideoDownloadProvider>> = ({
  children,
  onDownload,
  enableDownloadVideo,
}) => {
  return (
    <VideoDownloadContext.Provider value={{ onDownload, enableDownloadVideo }}>
      {children}
    </VideoDownloadContext.Provider>
  );
};

export const useVideoDownloadContext = () => {
  return React.useContext(VideoDownloadContext);
};
